import { BuzolaProvider, Outlet } from '@buzola/router'
import { Environment, EnvironmentContext, useEnvironment } from '@contember/react-binding'
import { pageRegistry, routes } from './buzola.gen'
import { getLastOrgId } from '~/lib/routing/org-context'

const rootEnv = Environment.create()

const ContemberEnvMiddleware = ({ params, children }: { params: Record<string, string>; children: React.ReactNode }) => {
	const env = useEnvironment().withParameters(params)
	return <EnvironmentContext.Provider value={env}>{children}</EnvironmentContext.Provider>
}

const persistentParams = (): Record<string, string> => {
	const orgId = getLastOrgId()
	return orgId ? { organizationId: orgId } : {}
}

export const Application = () => {
	return (
		<EnvironmentContext.Provider value={rootEnv}>
			<BuzolaProvider
				routes={routes}
				pageRegistry={pageRegistry}
				middleware={ContemberEnvMiddleware}
				persistentParams={persistentParams}
			>
				<Outlet />
			</BuzolaProvider>
		</EnvironmentContext.Provider>
	)
}
